import { QueryKeys } from "@app/constants/query-keys.ts";
import { useApis } from "@app/data/apis.ts";
import { useQuery } from "bi-lib";

export default function useLookupListData() {
    const apis = useApis();
    const stateCodeListQuery = useQuery({
        queryKey: [QueryKeys.StateCodeList],
        queryFn: () => apis.engine.lookupList.lookupListStateCodesListList(),
    });

    const getExtensionsListQuery = useQuery({
        queryKey: [QueryKeys.ExtensionsList],
        queryFn: () => apis.engine.lookupList.lookupListGetExtensionsListList(),
    });

    const getMembershipRolesListQuery = useQuery({
        queryKey: [QueryKeys.MembershipRolesList],
        queryFn: () => apis.engine.lookupList.lookupListGetMembershipRolesListList(),
    });

    const getUtilizationCodesListQuery = useQuery({
        queryKey: [QueryKeys.UtilizationCodesList],
        queryFn: () => apis.engine.lookupList.lookupListGetUtilizationCodesListList(),
    });

    const getBillingTermsListQuery = useQuery({
        queryKey: [QueryKeys.BillingTermsList],
        queryFn: () => apis.engine.lookupList.lookupListGetBillingTermsListList(),
    });

    const getInvoiceTypesListQuery = useQuery({
        queryKey: [QueryKeys.InvoiceTypesList],
        queryFn: () => apis.engine.lookupList.lookupListGetInvoiceTypesListList(),
    });

    const getInvoiceStylesListQuery = useQuery({
        queryKey: [QueryKeys.InvoiceStylesList],
        queryFn: () => apis.engine.lookupList.lookupListGetInvoiceStylesListList(),
    });

    const getProjectRolesListQuery = useQuery({
        queryKey: [QueryKeys.ProjectRolesList],
        queryFn: () => apis.engine.lookupList.lookupListGetProjectRolesListList(),
    });

    return {
        extensionsList: getExtensionsListQuery,
        stateCodeList: stateCodeListQuery,
        membershipRolesList: getMembershipRolesListQuery,
        utilizationCodesList: getUtilizationCodesListQuery,
        billingTermsList: getBillingTermsListQuery,
        invoiceTypes: getInvoiceTypesListQuery,
        invoiceStylesList: getInvoiceStylesListQuery,
        projectRoles: getProjectRolesListQuery,
    };
}
